import { NgModule } from '@angular/core';
import { CrmModuleConfigToken } from 'common-module/core';
import { LayoutCollapseProvider } from '@app/core/crm/layout/providers/layout-collapse.provider';

import { layoutConfig } from '../configuration/layout.config';

@NgModule({
  imports: [],
  exports: [],
  providers: [
    LayoutCollapseProvider,
    {
      provide: CrmModuleConfigToken,
      useValue: { layoutV2: layoutConfig },
      multi: true,
    },
  ],
})
export class LayoutModule {}
